<template>
  <app-load-content :loading="loading || !article">
    <div v-if="article !== null" id="editor-headline-wrapper" class="header clearfix">
      <a :href="article.url" target="_blank" title="Open Source">
        <h2 id="editor-headline" :class="'editor-headline ' + article.language_alignment" v-html="articleHeadline"></h2>
      </a>
      <h5 id="outlet-meta" class="meta-data">
        <span v-if="article.outlet" class="outlet-name">
          <a v-if="articleOutletUrl" :href="articleOutletUrl | fullUrl" target="_blank" title="Open Source">{{ articleOutletTitle }}</a>
          <p v-else title="Open Source" class="inline-block">{{ articleOutletTitle }}</p>
        </span>
        <i>{{ article.date | formattedDate }}</i>
      </h5>

      <div id="editor-meta" class="meta-data" v-if="articleHasAuthors">
        <span v-for="(author, index) in article.authors" :key="author.id">{{ author.first_name }} {{ author.last_name }}{{article.authors.length > index+1? ', ':''}}</span>
      </div>
      <div v-else id="no-editor-meta" class="meta-data">
        <h5>{{$t("article_content.no_author")}}</h5>
      </div>
    </div>

    <div v-if="article !== null" id="editor-body-wrapper" :class="{[article.language_alignment]: [article.language_alignment]}">
      <div class="social-embedded-container">
        <app-social-embedded
          :url="article.url || ''" 
         >
        </app-social-embedded>
      </div>
      <app-article-body-renderer v-for="(paragraph, index) in articleContent"
                                 :key="index"
                                 :paragraph="paragraph"
                                 :parKey="index"
                                 :selectedClassName="currentParagraphIndex !== -1 && currentParagraphIndex === index ? 'active-paragraph' : ''"
                                 :noOfSelectedSentences="noOfSelectedSentences"
      />
    </div>
  </app-load-content>
</template>

<script>
  import { mapState } from 'vuex';
  import moment from 'moment';
  import LoadContent from '../load-content';
  import ArticleBodyRenderer from './article_body_renderer';
  import SocialEmbedded from '@/components/social-embed/social-embedded'; 

export default {
  props: {
    analysisArticle: {
      type: Object,
      required: true
    },
    articleContent: {
      type: Array,
      required: true
    },
    articleHeadline: {
      type: String,
      default: ''
    },
    currentParagraphIndex: {
      type: Number,
      required: true
    },
    noOfSelectedSentences: {
      type: Number,
      required: true
    }
  },
  components: {
    'app-load-content': LoadContent,
    'app-article-body-renderer': ArticleBodyRenderer,
    'app-social-embedded': SocialEmbedded
  },
  computed: {
    ...mapState({
      loading: state => state.analysisArticle.analysisArticle.isBusy
    }),
    article () {
      return this.analysisArticle && this.analysisArticle.data && this.analysisArticle.data.data;
    },
    articleOutlet() { return this.article && this.article.outlet },
    articleOutletTitle() { return this.articleOutlet && this.articleOutlet.title },
    articleOutletUrl() { return this.articleOutlet && this.articleOutlet.url },
    articleAuthors() { return this.article && this.article.authors },
    articleHasAuthors() { return this.articleAuthors && this.articleAuthors.length },
  },
  filters: {
    formattedDate (value) {
      if (!value) return '';
      return moment(value).utc().format("DD MMMM YYYY");
    },
    fullUrl (value) {
      if (!value) return '';

      if(!value.match(/^http(s)?/)) {
        return 'http://' + value;
      }

      return value;
    }
  }
}
</script>

<style lang="scss" scoped>
.social-embedded-container {
  margin-bottom: 10px;
}
</style>